import { toDurationSec } from './toDurationSec';

export function formatDuration (input: unknown): string {
  const sec = toDurationSec(input);

  if (sec <= 0) {
    return '0:00';
  }

  const minutes = Math.floor(sec / 60);
  const seconds = sec % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
